export default __webpack_public_path__ + "static/media/high-five.e6b092ed.svg";